module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c328a73ec962d58e4553a5281ea07d7a.png";